import { Link, Outlet } from 'react-router-dom';
import { StepPhotoManagerProvider } from '../../../contexts/StepPhotoManagerContext';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { Flex, Icon, Image, Text } from '@chakra-ui/react';

export const PhotoManagerLayout = () => {
  return (
    <StepPhotoManagerProvider>
      <Flex p="32px" alignItems="center" gap={2} position="relative">
        <Link to="/adm/photo-manager">
          <Icon
            as={AiOutlineArrowLeft}
            color="#414042"
            fontSize="24px"
            position="absolute"
            right="3"
            top="3"
            cursor="pointer"
          />
        </Link>

        <Image
          src="https://via.placeholder.com/150"
          alt="Placeholder"
          w="62px"
          h="62px"
          objectFit="contain"
          rounded="full"
        />
        <Flex flexDir="column" color="#414042" fontSize="29px" fontWeight="bold" lineHeight={1.2}>
          <Text>PhotoManager</Text>
          <Text>Innovation Brindes</Text>
        </Flex>
      </Flex>
      <Outlet />
    </StepPhotoManagerProvider>
  );
};
